import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { DuplicateReviewStatus, UpdateDuplicateReview } from "../../../schemas/location";
import { queryKeys } from "../../query-keys";

export function useDuplicateReviews(status: DuplicateReviewStatus | "all" = "pending") {
	return useQuery({
		queryKey: queryKeys.duplicateReviews.list(status),
		queryFn: () => adminApi.locations.duplicateReviews.list(status),
	});
}

export function useUpdateDuplicateReview() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateDuplicateReview }) =>
			adminApi.locations.duplicateReviews.update(id, body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.duplicateReviews.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.locations.all });
		},
	});
}
